export var SiteInstallationStatus;
(function (SiteInstallationStatus) {
    SiteInstallationStatus["NOT_STARTED"] = "NOT_STARTED";
    SiteInstallationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    SiteInstallationStatus["COMPLETED"] = "COMPLETED";
    SiteInstallationStatus["DISCONTINUED"] = "DISCONTINUED";
})(SiteInstallationStatus || (SiteInstallationStatus = {}));
export var SolutionInstallationStatus;
(function (SolutionInstallationStatus) {
    SolutionInstallationStatus["NOT_NEEDED"] = "NOT_NEEDED";
    SolutionInstallationStatus["NOT_STARTED"] = "NOT_STARTED";
    SolutionInstallationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    SolutionInstallationStatus["COMPLETED"] = "COMPLETED";
    SolutionInstallationStatus["DISCONTINUED"] = "DISCONTINUED";
})(SolutionInstallationStatus || (SolutionInstallationStatus = {}));
export var SolutionInstallationStatusLabel;
(function (SolutionInstallationStatusLabel) {
    SolutionInstallationStatusLabel["NOT_NEEDED"] = "Not Needed";
    SolutionInstallationStatusLabel["NOT_STARTED"] = "Not Started";
    SolutionInstallationStatusLabel["IN_PROGRESS"] = "In Progress";
    SolutionInstallationStatusLabel["COMPLETED"] = "Completed";
})(SolutionInstallationStatusLabel || (SolutionInstallationStatusLabel = {}));
export var SolutionDeploymentStatusLabels;
(function (SolutionDeploymentStatusLabels) {
    SolutionDeploymentStatusLabels["NOT_NEEDED"] = "Not Needed";
    SolutionDeploymentStatusLabels["NOT_STARTED"] = "Devices Not Installed";
    SolutionDeploymentStatusLabels["IN_PROGRESS"] = "Installing";
    SolutionDeploymentStatusLabels["COMPLETED"] = "Active";
    SolutionDeploymentStatusLabels["DISCONTINUED"] = "Discontinued";
})(SolutionDeploymentStatusLabels || (SolutionDeploymentStatusLabels = {}));
export var SiteInstallationStatusLabel;
(function (SiteInstallationStatusLabel) {
    SiteInstallationStatusLabel["NOT_STARTED"] = "Not Started";
    SiteInstallationStatusLabel["IN_PROGRESS"] = "In Progress";
    SiteInstallationStatusLabel["COMPLETED"] = "Completed";
})(SiteInstallationStatusLabel || (SiteInstallationStatusLabel = {}));
export var SiteDeploymentStatusLabels;
(function (SiteDeploymentStatusLabels) {
    SiteDeploymentStatusLabels["NOT_STARTED"] = "Devices Not Installed";
    SiteDeploymentStatusLabels["IN_PROGRESS"] = "Installing";
    SiteDeploymentStatusLabels["COMPLETED"] = "Active";
    SiteDeploymentStatusLabels["DISCONTINUED"] = "Discontinued";
})(SiteDeploymentStatusLabels || (SiteDeploymentStatusLabels = {}));
export var SiteEnergyCalculationMode;
(function (SiteEnergyCalculationMode) {
    SiteEnergyCalculationMode["MDP_MAINS"] = "MDP_MAINS";
    SiteEnergyCalculationMode["MDP_BREAKERS"] = "MDP_BREAKERS";
    SiteEnergyCalculationMode["DP_MAINS"] = "DP_MAINS";
    SiteEnergyCalculationMode["DP_BREAKERS"] = "DP_BREAKERS";
    SiteEnergyCalculationMode["FLAGGED_BREAKERS"] = "FLAGGED_BREAKERS";
})(SiteEnergyCalculationMode || (SiteEnergyCalculationMode = {}));
export var SiteStatus;
(function (SiteStatus) {
    SiteStatus["ONLINE"] = "Online";
    SiteStatus["OFFLINE"] = "Offline";
    SiteStatus["PARTIALLY_OFF"] = "Partially Offline";
})(SiteStatus || (SiteStatus = {}));
